import {Flex, FlexProps, Spinner} from "@chakra-ui/react";

const Loading = (props: FlexProps) => (
  <Flex align="center" justify="center" {...props}>
    <Spinner color="gray.500" />
  </Flex>
);

export default Loading;
